import classNames from 'classnames'
import { Avatar, type IChipProps, IconButton, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export type IChipWithAvatarProps = IChipProps & {
  chipWithoutBorder?: boolean
  isLabelEllipsis?: boolean
}

export const ChipWithAvatar = ({
  label,
  onDelete,
  item,
  chipWithoutBorder,
  isLabelEllipsis,
}: IChipWithAvatarProps) => {
  const avatarInfo = item?.data?.avatarInfo ? item?.data.avatarInfo : item?.avatarProps?.info

  return (
    <div
      className={classNames(styles.wrap, {
        [styles.chipWithoutBorder]: chipWithoutBorder,
        [styles.labelEllipsis]: isLabelEllipsis,
      })}
    >
      {avatarInfo && (
        <Avatar
          className={styles.dropdownAvatar}
          online={item?.data?.isAway}
          info={avatarInfo}
          size={16}
        />
      )}
      <Typography
        ariaLabel='ChipLabel'
        variant='body-md-regular'
        color='var(--content-primary-primary)'
        ellipsis={isLabelEllipsis}
      >
        {label}
      </Typography>
      {onDelete && (
        <IconButton
          color='transparent'
          size='mini'
          icon='close'
          tag='div'
          variant='icon'
          fontSize={16}
          onClick={onDelete}
          ariaLabel='ChipClose'
          className={styles.icon}
        />
      )}
    </div>
  )
}
